import { schemaDiscriminator as e } from "./discriminator-metadata.js";
import { getRefName as t } from "./helpers/get-ref-name.js";
import { hasComplexArrayItems as n } from "./helpers/has-complex-array-items.js";
import { unwrapForRead as ee } from "./helpers/unwrap-for-read.js";
import { getCompositionsToRender as r, inferDiscriminatorMappingComposition as te } from "./helpers/get-compositions-to-render.js";
import ne from "../shared/ExternalDocs.vue.js";
import { resolveDynamicSchema as i, useDynamicScope as re } from "./helpers/dynamic-scope.js";
import { isTypeObject as a } from "./helpers/is-type-object.js";
import { partitionAllOfCompositions as ie } from "./helpers/partition-all-of-compositions.js";
import { SCHEMA_ANCESTORS_SYMBOL as ae, getCycleKey as oe } from "./helpers/schema-cycle.js";
import { toNodeKey as se, useSchemaExpansion as ce } from "./helpers/schema-expansion.js";
import { useLocalization as le } from "./localization/index.js";
import ue from "./SchemaRailPanel.vue.js";
import de from "./SchemaComposition.vue.js";
import { sortPropertyNames as fe } from "./helpers/sort-property-names.js";
import pe from "./components/CopyLinkButton.vue.js";
import me from "./components/WithBreadcrumb.vue.js";
import { getEnumValues as he } from "./helpers/get-enum-values.js";
import { getPropertyDescriptionKey as ge } from "./helpers/get-property-description.js";
import { typeSignatureInlinesEnum as _e } from "./helpers/get-type-signature-tokens.js";
import { normalizeObjectComposition as ve } from "./helpers/normalize-object-composition.js";
import { optimizeValueForDisplay as o } from "./helpers/optimize-value-for-display.js";
import { shouldDisplayDescription as ye } from "./helpers/should-display-description.js";
import { shouldDisplayHeading as be } from "./helpers/should-display-heading.js";
import xe from "./SchemaCollapsedPreview.vue.js";
import Se from "./SchemaEnums.vue.js";
import Ce from "./SchemaGutterToggle.vue.js";
import we from "./SchemaPropertyHeading.vue.js";
import Te from "./Schema.vue.js";
import { Fragment as Ee, computed as s, createBlock as c, createCommentVNode as l, createElementBlock as u, createElementVNode as De, createSlots as Oe, createTextVNode as ke, createVNode as d, defineComponent as f, inject as Ae, mergeProps as p, normalizeClass as je, onBeforeUnmount as Me, onScopeDispose as Ne, openBlock as m, ref as Pe, renderList as Fe, resolveDynamicComponent as Ie, toDisplayString as Le, toHandlers as Re, toRef as ze, unref as h, useId as g, useTemplateRef as _, watch as v, withCtx as y } from "vue";
import { resolve as Be } from "@scalar/workspace-store/resolve";
import { isArraySchema as b } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
import { ScalarMarkdown as Ve } from "@scalar/components/markdown";
import { isDynamicRef as He, resolveDynamicRef as Ue } from "@scalar/workspace-store/helpers/dynamic-ref";
import { ScalarWrappingText as x } from "@scalar/components/wrapping-text";
//#region src/schema/SchemaProperty.vue?vue&type=script&setup=true&lang.ts
var We = ["id"], Ge = {
	key: 0,
	class: "property-name-pattern-properties text-c-1! border-0! p-0! before:hidden!"
}, Ke = {
	key: 1,
	class: "property-name-additional-properties text-c-1! border-0! p-0! before:hidden!"
}, qe = ["id"], Je = {
	key: 0,
	class: "property-name-pattern-properties text-c-1! border-0! p-0! before:hidden!"
}, Ye = {
	key: 1,
	class: "property-name-additional-properties text-c-1! border-0! p-0! before:hidden!"
}, Xe = {
	key: 2,
	class: "property-description mt-1! has-[+.property-rule]:mb-1.5!"
}, Ze = ["id"], Qe = {
	key: 7,
	class: "children [.property-description+&]:mt-1.5!"
}, $e = Object.freeze({}), S = /*@__PURE__*/ f({
	__name: "SchemaProperty",
	props: {
		is: {},
		schema: {},
		extensionSource: {},
		noncollapsible: { type: Boolean },
		level: { default: 0 },
		depth: { default: 0 },
		name: {},
		required: {
			type: Boolean,
			default: !1
		},
		compact: {
			type: Boolean,
			default: !1
		},
		discriminator: {},
		description: {},
		hideModelNames: {
			type: Boolean,
			default: !1
		},
		hideHeading: { type: Boolean },
		modelName: {},
		variant: {},
		breadcrumb: {},
		eventBus: {},
		options: {},
		propertyNamesEnum: {},
		propertyNamesSchema: {},
		schemaContext: {},
		compositionPath: {},
		compositionPathSegment: {},
		cycleKey: {},
		scrollTargetId: {},
		specificationExtension: {},
		expansion: {}
	},
	setup(f) {
		let S = f, et = [
			"oneOf",
			"anyOf",
			"allOf"
		], tt = re(), C = s(() => ve(o(i(ee(S.schema), tt)), S.name)), w = s(() => {
			let { name: e } = S, t = C.value;
			return !!e && !!t?.allOf && ie(t).segments.some((e) => e.kind === "object" && a(e.schema));
		}), T = s(() => S.breadcrumb ? S.name ? [...S.breadcrumb, S.name] : S.breadcrumb : void 0), E = s(() => S.compositionPathSegment ? [...S.compositionPath ?? [], S.compositionPathSegment] : S.compositionPath ?? []), nt = s(() => [...E.value, "items"]), D = s(() => {
			let e = S.options.linkablePropertyPath, t = T.value;
			return S.level <= 2 || !!(e && t && e.length === t.length && e.every((e, n) => e === t[n]));
		}), rt = s(() => D.value && (T.value?.length ?? 0) > 0), O = s(() => {
			let e = C.value;
			if (!e || !b(e) || !He(e.items)) return e;
			let t = Ue(e.items.$dynamicRef, tt);
			return t ? {
				...e,
				items: t
			} : e;
		}), it = s(() => n(O.value)), at = s(() => st.value.length > 0), ot = s(() => C.value ? te(C.value, S.options.document) : null), k = s(() => {
			let e = C.value;
			if (!e || !("properties" in e || "additionalProperties" in e) || "allOf" in e || !(S.schema && typeof S.schema == "object" && "allOf" in S.schema) && ot.value) return !1;
			let t = "type" in e ? e.type : void 0, n = typeof t == "string" && t !== "object";
			return a(e) || !n;
		}), A = s(() => {
			let e = C.value;
			return !e || !b(e) || e.items === void 0 ? !1 : it.value;
		}), st = s(() => he(C.value)), ct = s(() => {
			let e = ge(C.value);
			return e ? I(e) : null;
		}), j = s(() => ye(C.value, S.description)), lt = s(() => {
			let e = C.value;
			if (!e) return e;
			let { oneOf: t, anyOf: n, allOf: ee, not: r, discriminator: te, externalDocs: ne, ...i } = e;
			if (j.value && "description" in i) {
				let { description: e, ...t } = i;
				return t;
			}
			return i;
		}), M = s(() => be(C.value, S.name, S.required)), ut = s(() => B.value || w.value ? [] : r(C.value, S.options.document, ot.value)), dt = s(() => S.extensionSource ? {
			...S.extensionSource,
			...C.value
		} : C.value), ft = s(() => {
			let e = dt.value;
			if (!e || typeof e != "object") return !1;
			for (let t in e) if (t.startsWith("x-")) return !0;
			return !1;
		}), pt = (e) => e === "allOf" ? S.schema?.discriminator ?? S.discriminator : S.schema?.discriminator, N = s(() => {
			let e = O.value;
			if (!e || !b(e) || e.items === void 0) return;
			let t = Be.schema(e.items);
			return et.some((e) => Array.isArray(t?.[e]) && t[e]?.length === 1) ? o(t) : t;
		}), mt = s(() => {
			let e = C.value;
			if (!(!e || !b(e))) return oe(e.items);
		}), P = s(() => ({
			compact: S.compact,
			eventBus: S.eventBus,
			hideModelNames: L.value,
			level: S.level + 1,
			name: S.name,
			options: S.options,
			schemaContext: S.schemaContext
		})), ht = s(() => k.value ? {
			...P.value,
			breadcrumb: T.value,
			compositionPath: E.value,
			cycleKey: S.cycleKey,
			schema: lt.value,
			discriminator: C.value?.discriminator ?? S.discriminator
		} : null), gt = s(() => A.value && N.value ? {
			...P.value,
			compositionPath: nt.value,
			cycleKey: mt.value,
			schema: Be.schema(N.value)
		} : null), F = s(() => {
			let { cycleKey: e } = S;
			return w.value ? {
				...P.value,
				breadcrumb: T.value,
				compositionPath: E.value,
				cycleKey: e,
				schema: C.value
			} : ht.value ?? gt.value;
		}), _t = s(() => !ht.value && !!gt.value), vt = s(() => S.name === S.discriminator?.propertyName ? S.discriminator?.[e]?.value : void 0), yt = s(() => !!(S.name && S.discriminator?.propertyName === S.name)), { translate: I } = le(), L = s(() => S.hideModelNames || !!S.options.hideModelNames), R = s(() => w.value || k.value || A.value), bt = Ae(ae, void 0), z = s(() => _t.value ? mt.value : S.cycleKey), B = s(() => z.value != null && !!bt?.has(z.value)), xt = s(() => {
			let e = z.value;
			if (typeof e == "string") {
				let n = t(e);
				if (n) return n;
			}
			return S.modelName || S.name || I("schema.schema");
		}), V = S.expansion ?? ce(ze(() => S.scrollTargetId ?? "")), St = g(), H = s(() => se(T.value) || `~anonymous-${St}`), U = s(() => R.value && !S.noncollapsible && M.value && !B.value), W = s(() => R.value && !!S.noncollapsible && !!S.name && M.value && !B.value), G = s(() => U.value && V.isExpanded(H.value, {
			cyclic: B.value,
			defaultOpen: !!S.options.expandAllSchemaProperties
		})), K = Pe(!1);
		v(G, (e, t) => {
			if (e) {
				K.value &&= (V.untilFound.release(), !1);
				return;
			}
			t && (K.value = Ct() && V.untilFound.acquire());
		}), Ne(() => {
			K.value &&= (V.untilFound.release(), !1);
		});
		let Ct = () => typeof document < "u" && "onbeforematch" in document.body, wt = s(() => W.value || U.value && (G.value || K.value)), Tt = s(() => W.value || G.value ? void 0 : "until-found"), Et = s(() => R.value && !B.value && !U.value && !W.value), Dt = g(), q = g(), Ot = g(), kt = _("treePanel"), J = _("treeToggle"), Y = null, X = () => {
			Y?.removeAttribute("data-heading-hovered"), Y = null;
		}, At = {
			pointerenter: (e) => {
				X();
				let t = e.currentTarget instanceof HTMLElement ? e.currentTarget.parentElement : null;
				t && (t.setAttribute("data-heading-hovered", ""), Y = t);
			},
			pointerleave: X
		};
		v(U, (e) => {
			e || X();
		}), Me(X), v(G, (e) => {
			if (e) return;
			let t = kt.value?.$el;
			t?.removeAttribute("data-rail-hovered"), t?.parentElement?.removeAttribute("data-child-rail-hovered");
		});
		let Z = s(() => _t.value ? N.value : lt.value), jt = s(() => Z.value ? fe(Z.value, void 0, S.options) : []), Q = s(() => {
			if (!R.value) return null;
			let e = Z.value;
			if (!e) return null;
			let t = S.options.hideReadOnly || S.options.hideWriteOnly ? jt.value.length : a(e) && e.properties ? Object.keys(e.properties).length : 0, n = "patternProperties" in e && e.patternProperties ? Object.keys(e.patternProperties).length : 0, ee = "additionalProperties" in e && e.additionalProperties ? 1 : 0, r = t + n + ee;
			return r === 0 ? null : I("schema.propertyCount", { count: String(r) });
		}), Mt = s(() => _e(C.value, { hideModelNames: L.value })), Nt = s(() => S.modelName || I("schema.schema")), $ = () => {
			let e = !G.value;
			if (!e) {
				let e = document.activeElement, t = J.value instanceof HTMLElement ? J.value : J.value?.$el;
				e && kt.value?.$el.contains(e) && t?.focus();
			}
			V.setExpanded(H.value, e);
		}, Pt = (e) => {
			if (!U.value) return;
			let t = e.target;
			t instanceof Element && t.closest("a, button, [role=\"button\"], input, select, label") || window.getSelection()?.toString() || $();
		}, Ft = () => {
			V.setExpanded(H.value, !0);
		};
		return (e, t) => (m(), c(Ie(f.is ?? "li"), { class: je(["property", [
			`property--level-${f.level}`,
			{
				"property--compact": f.compact,
				"property--deprecated": C.value?.deprecated
			},
			"property--tree grid! grid-cols-[minmax(0,1fr)] border-b-0! px-0! py-[var(--schema-row-pad,6px)]!",
			{ "property--tree-container": !U.value && !B.value && (R.value || !M.value) },
			`property--depth-${f.depth}`
		]]) }, {
			default: y(() => [
				U.value ? (m(), c(Ce, {
					key: 0,
					ref: "treeToggle",
					class: "absolute start-[calc(0px_-_var(--schema-toggle-half,12px)_-_var(--schema-gutter,16px))] top-2.5 z-[1] col-start-1 row-start-1 -translate-y-1/2 print:hidden",
					countId: Q.value ? h(Ot) : void 0,
					fallbackLabel: Nt.value,
					nameId: f.name ? h(q) : void 0,
					open: G.value,
					panelId: h(Dt),
					panelRendered: wt.value,
					onToggle: $
				}, null, 8, [
					"countId",
					"fallbackLabel",
					"nameId",
					"open",
					"panelId",
					"panelRendered"
				])) : l("", !0),
				M.value ? (m(), c(we, p({
					key: 1,
					class: ["group", [{ "cursor-pointer": U.value }, "relative row-start-1 min-h-5 content-center [&>*:has(+.copy-link-trailing)]:me-0!"]],
					discriminatorValue: vt.value,
					enum: at.value,
					eventBus: f.eventBus,
					hideModelNames: L.value,
					isDiscriminator: yt.value,
					keyKind: f.variant === "additionalProperties" ? "additional" : f.variant === "patternProperties" ? "pattern" : void 0,
					modelLinkOptions: {
						hideModels: f.options.hideModels,
						document: f.options.document
					},
					modelName: f.modelName,
					propertyNames: f.propertyNamesSchema,
					recursiveTo: B.value ? xt.value : void 0,
					required: f.required,
					value: C.value
				}, Re(U.value ? At : h($e)), { onClick: Pt }), Oe({ _: 2 }, [
					f.name ? {
						name: "name",
						fn: y(() => [rt.value ? (m(), c(me, {
							key: 0,
							breadcrumb: T.value
						}, {
							default: y(() => [De("span", { id: h(q) }, [f.variant === "patternProperties" ? (m(), u("span", Ge, [d(h(x), {
								preset: "property",
								text: f.name
							}, null, 8, ["text"])])) : f.variant === "additionalProperties" ? (m(), u("span", Ke, [d(h(x), {
								preset: "property",
								text: f.name
							}, null, 8, ["text"])])) : (m(), c(h(x), {
								key: 2,
								preset: "property",
								text: f.name
							}, null, 8, ["text"]))], 8, We)]),
							_: 1
						}, 8, ["breadcrumb"])) : (m(), u("span", {
							key: 1,
							id: h(q)
						}, [f.variant === "patternProperties" ? (m(), u("span", Je, [d(h(x), {
							preset: "property",
							text: f.name
						}, null, 8, ["text"])])) : f.variant === "additionalProperties" ? (m(), u("span", Ye, [d(h(x), {
							preset: "property",
							text: f.name
						}, null, 8, ["text"])])) : (m(), c(h(x), {
							key: 2,
							preset: "property",
							text: f.name
						}, null, 8, ["text"]))], 8, qe))]),
						key: "0"
					} : void 0,
					C.value?.example === void 0 ? void 0 : {
						name: "example",
						fn: y(() => [ke(" Example: " + Le(C.value.example), 1)]),
						key: "1"
					},
					U.value && !G.value ? {
						name: "preview",
						fn: y(() => [d(xe, {
							"aria-hidden": "true",
							class: "mr-0!",
							propertyNames: jt.value,
							schema: Z.value
						}, null, 8, ["propertyNames", "schema"])]),
						key: "2"
					} : void 0,
					f.name && D.value && T.value ? {
						name: "trailing",
						fn: y(() => [d(pe, {
							anchorId: T.value.join("."),
							eventBus: f.eventBus
						}, null, 8, ["anchorId", "eventBus"])]),
						key: "3"
					} : void 0
				]), 1040, [
					"class",
					"discriminatorValue",
					"enum",
					"eventBus",
					"hideModelNames",
					"isDiscriminator",
					"keyKind",
					"modelLinkOptions",
					"modelName",
					"propertyNames",
					"recursiveTo",
					"required",
					"value"
				])) : l("", !0),
				d(ne, {
					class: "my-2",
					value: C.value?.externalDocs
				}, null, 8, ["value"]),
				j.value || ct.value ? (m(), u("div", Xe, [d(h(Ve), { value: j.value || ct.value || "" }, null, 8, ["value"])])) : l("", !0),
				f.propertyNamesEnum && f.propertyNamesEnum.length > 0 ? (m(), c(Se, {
					key: 3,
					propertyNames: "",
					value: { enum: f.propertyNamesEnum }
				}, null, 8, ["value"])) : l("", !0),
				st.value.length > 0 && !A.value && !Mt.value ? (m(), c(Se, {
					key: 4,
					value: C.value
				}, null, 8, ["value"])) : l("", !0),
				U.value && Q.value ? (m(), u("span", {
					key: 5,
					id: h(Ot),
					class: "screenreader-only"
				}, Le(Q.value), 9, Ze)) : l("", !0),
				wt.value ? (m(), c(ue, {
					key: 6,
					id: h(Dt),
					ref: "treePanel",
					class: "property-children mt-1.5 mb-0.5 [&_.schema-card]:mb-0! [&_.schema-card]:pb-0! [&_.schema-properties]:mb-0! [&_.schema-properties]:pb-0! [&_ul]:my-0! [&_ul]:py-0! [&[hidden=until-found]]:my-0 [&[hidden=until-found]]:border-s-0 [&[hidden]:not([hidden=until-found])]:hidden",
					closeOnRail: U.value,
					depth: f.depth + 1,
					hidden: Tt.value,
					onBeforematch: Ft,
					onClose: $
				}, {
					default: y(() => [F.value ? (m(), c(Te, p({ key: 0 }, F.value, {
						depth: f.depth + 1,
						expansion: h(V),
						noncollapsible: "",
						scrollTargetId: f.scrollTargetId,
						specificationExtension: f.specificationExtension
					}), null, 16, [
						"depth",
						"expansion",
						"scrollTargetId",
						"specificationExtension"
					])) : l("", !0)]),
					_: 1
				}, 8, [
					"id",
					"closeOnRail",
					"depth",
					"hidden"
				])) : l("", !0),
				Et.value ? (m(), u("div", Qe, [F.value ? (m(), c(Te, p({ key: 0 }, F.value, {
					depth: f.depth,
					expansion: h(V),
					noncollapsible: "",
					scrollTargetId: f.scrollTargetId,
					specificationExtension: f.specificationExtension
				}), null, 16, [
					"depth",
					"expansion",
					"scrollTargetId",
					"specificationExtension"
				])) : l("", !0)])) : l("", !0),
				(m(!0), u(Ee, null, Fe(ut.value, (e) => (m(), c(de, {
					key: e.composition,
					breadcrumb: T.value,
					compact: f.compact,
					composition: e.composition,
					compositionPath: E.value,
					depth: f.depth,
					discriminator: pt(e.composition),
					eventBus: f.eventBus,
					expansion: h(V),
					hideHeading: f.hideHeading,
					hideModelNames: L.value,
					level: f.level,
					name: f.name,
					noncollapsible: f.noncollapsible,
					options: f.options,
					schema: e.value,
					schemaContext: f.schemaContext,
					scrollTargetId: f.scrollTargetId,
					specificationExtension: f.specificationExtension
				}, null, 8, [
					"breadcrumb",
					"compact",
					"composition",
					"compositionPath",
					"depth",
					"discriminator",
					"eventBus",
					"expansion",
					"hideHeading",
					"hideModelNames",
					"level",
					"name",
					"noncollapsible",
					"options",
					"schema",
					"schemaContext",
					"scrollTargetId",
					"specificationExtension"
				]))), 128)),
				ft.value && f.specificationExtension ? (m(), c(Ie(f.specificationExtension), {
					key: 8,
					showExtensions: f.options.showExtensions,
					value: dt.value
				}, null, 8, ["showExtensions", "value"])) : l("", !0)
			]),
			_: 1
		}, 8, ["class"]));
	}
});
//#endregion
export { S as default };

//# sourceMappingURL=SchemaProperty.vue.script.js.map